// i18n minimal et autonome (sans dépendance externe)
import { useState, useEffect, useCallback } from "react";

const resources = {
  fr: {
    "nav.dashboard": "Tableau de bord", "nav.diagnostic": "Plan de réussite", "nav.courses": "Cours",
    "nav.filieres": "Filières techniques", "nav.sprint": "Dernière ligne droite", "nav.tutor": "Professeur IA",
    "nav.simulator": "Examens blancs", "nav.revisions": "Révisions", "nav.archive": "Banque de sujets",
    "nav.leaderboard": "Classement", "nav.pricing": "Abonnement", "nav.parent": "Mon enfant",
    "nav.teacher": "Espace enseignant", "nav.school": "Établissement", "nav.admin": "Back-office",
    "common.online": "En ligne", "common.offline": "Hors connexion", "common.pending": "en attente de synchro",
    "landing.badge": "N°1 de la préparation aux examens au Cameroun",
    "landing.hero": "YAYA EXAM ACADEMY prépare les candidats aux examens officiels du Cameroun — secondaire général, technique, professionnel et anglophone — grâce à une IA pédagogique conforme aux programmes.",
    "landing.login": "Connexion", "landing.start": "Commencer",
  },
  en: {
    "nav.dashboard": "Dashboard", "nav.diagnostic": "Success plan", "nav.courses": "Courses",
    "nav.filieres": "Technical tracks", "nav.sprint": "Final stretch", "nav.tutor": "AI Teacher",
    "nav.simulator": "Mock exams", "nav.revisions": "Revision", "nav.archive": "Past papers",
    "nav.leaderboard": "Leaderboard", "nav.pricing": "Subscription", "nav.parent": "My child",
    "nav.teacher": "Teacher space", "nav.school": "Institution", "nav.admin": "Back-office",
    "common.online": "Online", "common.offline": "Offline", "common.pending": "pending sync",
    "landing.badge": "#1 exam preparation in Cameroon",
    "landing.hero": "YAYA EXAM ACADEMY prepares candidates for Cameroon's official exams — general, technical, vocational and Anglophone secondary — with a curriculum-aligned learning AI.",
    "landing.login": "Log in", "landing.start": "Get started",
  },
};

let currentLang = (typeof localStorage !== "undefined" && localStorage.getItem("yaya_lang")) || "fr";

export const getLang = () => currentLang;
export const translate = (key, fallback) => (resources[currentLang] && resources[currentLang][key]) || fallback || key;

export const setLang = (lng) => {
  currentLang = lng;
  if (typeof localStorage !== "undefined") localStorage.setItem("yaya_lang", lng);
  window.dispatchEvent(new Event("yaya-lang-change"));
};

export function useTranslation() {
  const [lang, setL] = useState(currentLang);
  useEffect(() => {
    const h = () => setL(currentLang);
    window.addEventListener("yaya-lang-change", h);
    return () => window.removeEventListener("yaya-lang-change", h);
  }, []);
  const t = useCallback((key, fallback) => translate(key, fallback), [lang]);
  return { t, i18n: { language: lang, changeLanguage: setLang } };
}

export default { getLang, setLang, translate };
